<template>
	<nk-page :policyClaims="['Settings_SaleBuy_SaleBuy']">
		<template #badges v-if="localSettings.loadFromRemote">
			<nk-badge system="sale">
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`setting.title`)"></nk-badge-item>
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`setting.${formManager === 'Product' ? 'productSettings' : 'saleSettings'}.title`)"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="container-fluid nk-card h-100 ">
			<div class="form-container" ref="settingSale">
				<nk-stabs>
					<nk-stab :id="'factor-settings'" :name="$t('setting.sale.tabs.factor-settings')" v-if="(!formManager || formManager === 'Factor') && $nikan.checkCommercialAccess('Sale')">
						<div class="nk-card">
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.factorBunch-default') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 4, md: 3 }">
										<nk-dropdown v-model="localData.factorSettings.defaultFactorBunch" :options="componentOptions.factorBunch" :data="factorBunches" :tabindex="100" startup ref="factorBunchDrp"></nk-dropdown>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.taxPercent') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 2, md: 1 }">
										<nk-input v-model="localData.factorSettings.taxPercent" :options="componentOptions.percent" :tabindex="101" startup></nk-input>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.tollPercent') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 2, md: 1 }">
										<nk-input v-model="localData.factorSettings.tollPercent" :options="componentOptions.percent" :tabindex="102" startup></nk-input>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.autoFactorCode') + ':'" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }">
										<nk-switch v-model="localData.factorSettings.autoFactorCode" :tabindex="103" startup></nk-switch>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.allow-out-of-date-factor') + ':'" :labelSizes="{ xs: 8, sm: 4 }" :dataSizes="{ xs: 4, sm: 8 }">
										<nk-switch v-model="localData.factorSettings.allowOutOfDateFactor" :tabindex="104" startup></nk-switch>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.allow-negative-sale') + ':'" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }">
										<nk-switch v-model="localData.factorSettings.allowNegativeSale" :tabindex="105" startup></nk-switch>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.check-sale-price-base-on-buy-price') + ':'" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }">
										<nk-switch v-model="localData.factorSettings.checkingSalePriceBaseOnBuyPrice" :tabindex="106" startup></nk-switch>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.insert-floating-centers-in-sale-row') + ':'" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }">
										<nk-switch v-model="localData.factorSettings.insertFloatingCentersInSaleRow" :tabindex="107" startup></nk-switch>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.auto-hawala-issuance') + ':'" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }">
										<nk-switch v-model="localData.factorSettings.autoHawalaIssuance" :tabindex="108" startup></nk-switch>
									</nk-col-form-group>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-sm-12">
									<nk-col-form-group :label="$t('setting.sale.f.stock-by') + ':'" :labelSizes="{ xs: 4, sm: 4 }" :dataSizes="{ xs: 8, sm: 8 }">
										<div class="d-flex">
											<nk-radio :group="'report-type'" :tabindex="109" :options="componentOptions.radioFactor" v-model="negativeInventoryCheckType" />
											<nk-radio :group="'report-type'" :tabindex="110" :options="componentOptions.radioWarehouse" v-model="negativeInventoryCheckType" />
										</div>
									</nk-col-form-group>
								</div>
							</div>
						</div>
					</nk-stab>
					<nk-stab :id="'product-settings'" :name="$t('setting.sale.tabs.product-settings')" v-if="(!formManager || formManager === 'Product') && $nikan.checkCommercialAccess(['Sale', 'Warehouse'])">
						<div class="row">
							<div class="col-12 col-sm-6">
								<nk-col-form-group :label="$t('setting.sale.f.product-keepCodeSerial') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
									<nk-switch v-model="localData.productSettings.keepCodeSerial" :tabindex="105" startup></nk-switch>
								</nk-col-form-group>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-sm-6">
								<nk-col-form-group :label="$t('setting.sale.f.product-useGroupCoding') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
									<nk-switch v-model="localData.productSettings.useGroupCoding" :tabindex="107"></nk-switch>
								</nk-col-form-group>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-sm-6">
								<nk-col-form-group :label="$t('setting.sale.f.product-groupCodingDigitNumberCount') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
									<nk-input v-model="localData.productSettings.groupCodingDigitNumberCount" :options="componentOptions.groupCoding" :tabindex="109"></nk-input>
								</nk-col-form-group>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-sm-6">
								<nk-col-form-group :label="$t('setting.sale.f.product-codePattern') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
									<nk-dropdown v-model="localData.productSettings.codePattern" :data="codePatternList" :options="componentOptions.codePattern" :tabindex="110"></nk-dropdown>
								</nk-col-form-group>
							</div>
						</div>
						<div class="nk-card mt-4">
							<span>{{ $t('setting.sale.f.search-priority') }}:</span>
							<div class="search-priority-box">
								<table class="table table-border text-right table-priority">
									<tr v-for="(item, index) in orderedProductSearchPriorities" :key="item.Field">
										<td class="handlers" style="width:30px">
											<div>
												<i :class="['fas fa-chevron-up up', { 'disable': index == 0 }]" @click="moveUp(item, index)"></i>
											</div>
											<div>
												<i :class="['fas fa-chevron-down down', { 'disable': index >= orderedProductSearchPriorities.length - 1 }]" @click="moveDown(item, index)"></i>
											</div>
										</td>
										<td style="width:75px">
											<span class="font-weight-bold">{{ $t(`sale.product.f.${item.Field}`) }}</span>
										</td>
										<td style="width: 90px">
											<span>{{ $t('setting.sale.f.search-method') }}:</span>
										</td>
										<td style="width: 150px">
											<nk-dropdown v-model="item.SearchMethod" :options="componentOptions.searchMethod" :data="searchMethods"></nk-dropdown>
										</td>
										<td style="width: 100px">
											<span>{{ $t('setting.sale.f.stop-on-find') }}:</span>
										</td>
										<td style="width: 50px">
											<nk-switch v-model="item.FindStop"></nk-switch>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</nk-stab>
				</nk-stabs>

			</div>
		</div>
	</nk-page>
</template>
<script>
	import $ from 'jquery'
	import _ from 'lodash'
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'

	export default {
		props: {
			data: {},
			options: {},
		},
		modal: {
			helpTag: 'SettingsSale'
		},
		data() {
			return {
				codePatternList: [],
				negativeInventoryCheckType: 'Warehouse',
				componentOptions: {
					codePattern: {
						rowIdentifier: 'id',
						searchable: true,
						required: true,
						placeholder: this.$t('search-it'),
						display: (item) => `${item.name}`,
					},
					groupCoding: {
						mode: 'number',
						min: 1,
						max: 13
					},
					float: {
						mode: 'float',
					},
					percent: {
						mode: 'percent',
						icon: 'percent',
					},
					factorBunch: {
						rowIdentifier: 'id',
						searchable: true,
						required: true,
						placeholder: this.$t('search-it'),
						display: (item) =>
							`${item.name} [${item.lastSerialNumber} - ${item.firstSerialNumber}]`,
						searchableFields: ['name', 'FirstSerialNumber', 'LastSerialNumber'],
						selectorWidth: '400px',
					},
					searchMethod: {
						searchable: false,
						required: true,
						placeholder: '',
						display: (item) => `${this.$t(item)}`,
						selectorWidth: '100px',
					},
					radioFactor: {
						title: this.$t('reports.product-cardex.dependOnFactor'),
						color: 'purple',
						value: 'Factor',
					},
					radioWarehouse: {
						title: this.$t('reports.product-cardex.dependOnWarehouse'),
						color: 'purple',
						value: 'Warehouse',
					},
				},
				settings: {
					loadFromRemote: true,
					form: null,
				},
				defaultData: {
					factorSettings: {
						taxPercent: 0,
						tollPercent: 0,
					},
					productSettings: {
						keepCodeSerial: true,
						codePatternId: null,
					}
				},
				remoteData: null,
				factorBunches: [],
				searchMethods: ['equal', 'startWith', 'contain'],
				orderedProductSearchPriorities: [],
				saveSaleSettingsButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					icon: 'save',
					handle: (button, page, e) => {
						e.preventDefault()
						this.saveSettings()
					},
					policyClaims: 'Settings_SaleBuy_SaleEdit',
				},
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.extend({}, this.settings, val)
				},
			},
		},
		computed: {
			localSettings() {
				return _.extend({}, this.settings, this.options)
			},
			localData() {
				if (this.localSettings.loadFromRemote) {
					return this.remoteData || this.defaultData
				} else {
					return this.data || this.defaultData
				}
			},
			formManager() {
				switch (this.settings.form) {
					case 'Sale':
					case 'Buy':
					case 'SaleReturn':
					case 'BuyReturn':
					case 'Proforma':
						return 'Factor'
					default:
						return this.settings.form

				}
			}
		},
		created() {
			if (this.localSettings.loadFromRemote) {
				this.remoteData = this.defaultData
			}
		},
		mounted() {
			this.getSettings()

			if (this.grandParentType() === 'modal')
				this.saveSaleSettingsButton.isPrimary = true

			this.prepareWindow(this.$t('setting.saleSettings.title'), [
				this.saveSaleSettingsButton,
			])
		},
		methods: {
			loadCodePatternList() {
				return new Promise((resolve, reject) => {
					var wait = this.$wait(this.$refs.settingSale)
					post(Endpoints.getUrl('codepattern.list'))
						.then((result) => {
							wait.end()
							this.codePatternList = result.data.items.filter(x => x.entityType === 'ProductCode')
							resolve()
						})
						.catch(() => {
							wait.end()
							reject()
						})
				})
			},
			loadFactorBunches() {
				return new Promise((resolve, reject) => {
					var wait = this.$wait(this.$refs.settingSale)
					post(Endpoints.getUrl('sale.factor.bunch.get-list-dynamic'))
						.then((result) => {
							wait.end()
							this.factorBunches = result.data.items
						})
						.catch(() => {
							wait.end()
							reject()
						})
				})
			},
			getSettings() {
				this.loadFactorBunches()
				this.loadCodePatternList()

				var wait = this.$wait(this.$refs.settingSale)

				post(Endpoints.getUrl('sale.settings.get'), null, null, { preventConcurrent: false })
					.then((result) => {
						wait.end()
						this.remoteData = result.data
						this.negativeInventoryCheckType = this.remoteData.factorSettings.useFactorInventory ? 'Factor' : 'Warehouse'
						let list = JSON.parse(
							result.data.factorSettings.productSearchPrioritiesJson
						)
						this.orderedProductSearchPriorities = _.orderBy(
							list || [],
							['Priority'],
							['asc']
						)
						this.remoteData.factorSettings.defaultFactorBunch =
							this.factorBunches.find(
								(x) => x.id == this.remoteData.factorSettings.defaultFactorBunchId
							)

						this.remoteData.productSettings.codePattern = this.codePatternList.find(
							(x) => x.id == this.remoteData.productSettings.codePatternId
						)
					})
					.catch(() => {
						wait.end()
					})
			},
			saveSettings() {
				var wait = this.$wait(this.grandParent)
				this.localData.type = 'FiscalPeriod'
				var setting = this.localData
				setting.factorSettings.useFactorInventory = this.negativeInventoryCheckType === 'Factor'
				setting.factorSettings.productSearchPrioritiesJson = JSON.stringify(this.orderedProductSearchPriorities)
				if (setting.factorSettings.defaultFactorBunch) {
					setting.factorSettings.defaultFactorBunchId = setting.factorSettings.defaultFactorBunch.id
				}

				setting.productSettings.codePatternId = setting.productSettings.codePattern ? setting.productSettings.codePattern.id : null

				post(Endpoints.getUrl('sale.settings.modify'), { setting: setting })
					.then((result) => {
						wait.end()
						this.$toast(this.$t('msg.create-success'), { type: 'success' })

						// closes form if it's modal
						if (this.grandParentType() === 'modal')
							this.resolve()
					})
					.catch(() => {
						wait.end()
					})
			},
			moveUp(item, currentIndex) {
				if (currentIndex <= 0 || this.orderedProductSearchPriorities.length == 0)
					return
				let dest = this.orderedProductSearchPriorities[currentIndex - 1]
				dest.Priority = currentIndex
				item.Priority = currentIndex - 1
				this.orderedProductSearchPriorities = _.orderBy(
					this.orderedProductSearchPriorities || [],
					['Priority'],
					['asc']
				)
			},
			moveDown(item, currentIndex) {
				if (currentIndex >= this.orderedProductSearchPriorities.length - 1) return
				let dest = this.orderedProductSearchPriorities[currentIndex + 1]
				dest.Priority = currentIndex
				item.Priority = currentIndex + 1
				this.orderedProductSearchPriorities = _.orderBy(
					this.orderedProductSearchPriorities || [],
					['Priority'],
					['asc']
				)
			},
		},
	}
</script>
<style>
	.search-priority-box {
		background-color: whitesmoke;
		padding: 10px;
	}

	.handlers .up,
	.handlers .down {
		cursor: pointer;
		color: #8a8a8a;
		border-radius: 30px;
		box-shadow: 0 0 4px #ddd;
		padding: 2px;
		transition: all 0.3s;
	}

	.handlers .up:hover,
	.handlers .down:hover {
		color: red;
		box-shadow: 0 3px 6px #ddd;
	}

	.handlers .disable {
		color: #eaeaea;
	}

	.handlers .up.disable:hover,
	.handlers .down.disable:hover {
		color: #eaeaea;
	}

	.table td {
		vertical-align: middle;
	}

	.table .handlers {
		padding: 0 5px;
	}

	.search-priority-box .table tr:first-child td {
		border-top: none;
	}

	.search-priority-box .table tr:hover {
		background-color: #fff;
	}

	.search-priority-box .drop-zone {
		border-top: 1px solid #ddd;
		padding: 10px;
	}

	.search-priority-box .drop-zone>div {
		display: flex;
	}

	.search-priority-box .drop-zone>div>div {
		padding: 5px;
	}

	.search-priority-box .drop-zone:first-child {
		border-top: none;
	}

	.search-priority-box .drop-zone:hover {
		background-color: #fff;
	}
</style>
